import 'svelte/internal/disclose-version';

Header[$.FILENAME] = 'src/components/Header.svelte';

import * as $ from 'svelte/internal/client';
import SearchBar from "./SearchBar.svelte";
import Avatar from "./Avatar.svelte";
import { session, logout } from "../lib/session.svelte.js";
import { prefs, cycleTheme } from "../lib/prefs.svelte.js";
import { navigate } from "../lib/router.svelte.js";
import { toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<a href="/admin" class="svelte-oiwvqb">Admin</a>`), Header[$.FILENAME], [[59, 16]]);

var root_1 = $.add_locations($.from_html(`<button type="button" class="backdrop svelte-oiwvqb" aria-label="Close menu"></button> <div class="menu svelte-oiwvqb"><div class="who svelte-oiwvqb"><strong> </strong> <span class="svelte-oiwvqb"> </span></div> <a href="/me" class="svelte-oiwvqb">Your list &amp; reviews</a> <!> <button type="button" class="svelte-oiwvqb">Sign out</button></div>`, 1), Header[$.FILENAME], [
	[51, 12],
	[52, 12, [[53, 14, [[54, 16], [55, 16]]], [57, 14], [61, 14]]]
]);

var root_2 = $.add_locations($.from_html(`<div class="menu-wrap svelte-oiwvqb"><button class="avatar-button svelte-oiwvqb" type="button"><!></button> <!></div>`), Header[$.FILENAME], [[46, 8, [[47, 10]]]]);
var root_3 = $.add_locations($.from_html(`<a class="ghost svelte-oiwvqb" href="/login">Log in</a> <a class="primary svelte-oiwvqb" href="/register">Join</a>`, 1), Header[$.FILENAME], [[66, 8], [67, 8]]);

var root_4 = $.add_locations($.from_html(`<header class="svelte-oiwvqb"><div class="bar svelte-oiwvqb"><a class="brand svelte-oiwvqb" href="/" aria-label="Upsorok home"><svg viewBox="0 0 64 64" aria-hidden="true" class="svelte-oiwvqb"><rect width="64" height="64" rx="16" fill="var(--accent)"></rect><path d="M20 14v16a6 6 0 0 0 6 6v14a2 2 0 0 0 4 0V36a6 6 0 0 0 6-6V14a2 2 0 0 0-4 0v12a2 2 0 0 1-4 0V14a2 2 0 0 0-4 0v12a2 2 0 0 1-4 0V14a2 2 0 0 0-4 0Z" fill="#fff"></path><path d="M44 14c-3 3-4 8-4 13s2 8 4 9v14a2 2 0 0 0 4 0V14a2 2 0 0 0-4 0Z" fill="#fff"></path></svg> <span class="svelte-oiwvqb">Upsorok</span></a> <!> <nav class="svelte-oiwvqb"><button class="ghost theme svelte-oiwvqb" type="button"><!> <span class="sr-only"> </span></button> <!></nav></div></header>`), Header[$.FILENAME], [
	[
		23,
		0,
		[
			[
				24,
				2,
				[
					[25, 4, [[26, 6, [[27, 8], [28, 8], [32, 8]]], [34, 6]]],
					[39, 4, [[40, 6, [[42, 8]]]]]
				]
			]
		]
	]
]);

const $$css = {
	hash: 'svelte-oiwvqb',
	code: '\n  header.svelte-oiwvqb {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    background: color-mix(in srgb, var(--paper) 88%, transparent);\n    backdrop-filter: blur(12px);\n    border-bottom: 1px solid var(--line);\n  }\n\n  .bar.svelte-oiwvqb {\n    max-width: var(--max-w);\n    margin: 0 auto;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .brand.svelte-oiwvqb {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    font-family: var(--font);\n    font-size: 1.28rem;\n    font-weight: 700;\n    color: var(--accent);\n    flex: none;\n  }\n  .brand.svelte-oiwvqb svg:where(.svelte-oiwvqb) { width: 30px; height: 30px; border-radius: 9px; }\n\n  nav.svelte-oiwvqb { display: flex; align-items: center; gap: 8px; flex: none; }\n\n  .ghost.svelte-oiwvqb, .primary.svelte-oiwvqb {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 9px 15px;\n    border-radius: var(--radius-pill);\n    font-size: 0.9rem;\n    font-weight: 600;\n    border: 1px solid transparent;\n    cursor: pointer;\n    background: none;\n    white-space: nowrap;\n  }\n  .ghost.svelte-oiwvqb { color: var(--ink-soft); }\n  .ghost.svelte-oiwvqb:hover { background: var(--card); color: var(--ink); border-color: var(--line); }\n  .primary.svelte-oiwvqb { background: var(--accent); color: #fff; }\n  .primary.svelte-oiwvqb:hover { background: var(--accent-dark); }\n  .theme.svelte-oiwvqb { font-size: 1rem; padding: 8px 11px; }\n\n  .menu-wrap.svelte-oiwvqb { position: relative; }\n  .avatar-button.svelte-oiwvqb { background: none; border: none; padding: 0; cursor: pointer; border-radius: 50%; }\n  .backdrop.svelte-oiwvqb { position: fixed; inset: 0; z-index: 55; border: none; background: none; cursor: default; padding: 0; }\n\n  .menu.svelte-oiwvqb {\n    position: absolute;\n    right: 0;\n    top: calc(100% + 10px);\n    z-index: 60;\n    min-width: 218px;\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-lg);\n    padding: 6px;\n    display: flex;\n    flex-direction: column;\n  }\n  .menu.svelte-oiwvqb .who:where(.svelte-oiwvqb) {\n    padding: 10px 12px 12px;\n    border-bottom: 1px solid var(--line);\n    margin-bottom: 6px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n  .menu.svelte-oiwvqb .who:where(.svelte-oiwvqb) span:where(.svelte-oiwvqb) { font-size: 0.78rem; color: var(--ink-faint); overflow: hidden; text-overflow: ellipsis; }\n  .menu.svelte-oiwvqb a:where(.svelte-oiwvqb), .menu.svelte-oiwvqb button:where(.svelte-oiwvqb) {\n    text-align: left;\n    padding: 10px 12px;\n    border-radius: var(--radius-sm);\n    border: none;\n    background: none;\n    font-size: 0.9rem;\n    cursor: pointer;\n  }\n  .menu.svelte-oiwvqb a:where(.svelte-oiwvqb):hover, .menu.svelte-oiwvqb button:where(.svelte-oiwvqb):hover { background: var(--accent-soft); }\n\n  @media (max-width: 720px) {\n    .bar.svelte-oiwvqb { flex-wrap: wrap; padding: 10px 14px; gap: 10px; }\n    .brand.svelte-oiwvqb span:where(.svelte-oiwvqb) { display: none; }\n    .search { order: 3; flex-basis: 100%; }\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLnN2ZWx0ZSIsInNvdXJjZXMiOlsiSGVhZGVyLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0PlxuICBpbXBvcnQgU2VhcmNoQmFyIGZyb20gXCIuL1NlYXJjaEJhci5zdmVsdGVcIjtcbiAgaW1wb3J0IEF2YXRhciBmcm9tIFwiLi9BdmF0YXIuc3ZlbHRlXCI7XG4gIGltcG9ydCB7IHNlc3Npb24sIGxvZ291dCB9IGZyb20gXCIuLi9saWIvc2Vzc2lvbi5zdmVsdGUuanNcIjtcbiAgaW1wb3J0IHsgcHJlZnMsIGN5Y2xlVGhlbWUgfSBmcm9tIFwiLi4vbGliL3ByZWZzLnN2ZWx0ZS5qc1wiO1xuICBpbXBvcnQgeyBuYXZpZ2F0ZSB9IGZyb20gXCIuLi9saWIvcm91dGVyLnN2ZWx0ZS5qc1wiO1xuICBpbXBvcnQgeyB0b2FzdFN1Y2Nlc3MgfSBmcm9tIFwiLi4vbGliL3RvYXN0LnN2ZWx0ZS5qc1wiO1xuXG4gIGxldCBtZW51T3BlbiA9ICRzdGF0ZShmYWxzZSk7XG5cbiAgY29uc3QgdGhlbWVMYWJlbCA9ICRkZXJpdmVkKFxuICAgIHByZWZzLnRoZW1lID09PSBcImRhcmtcIiA/IFwiRGFya1wiIDogcHJlZnMudGhlbWUgPT09IFwibGlnaHRcIiA/IFwiTGlnaHRcIiA6IFwiQXV0b1wiLFxuICApO1xuXG4gIGFzeW5jIGZ1bmN0aW9uIHNpZ25PdXQoKSB7XG4gICAgbWVudU9wZW4gPSBmYWxzZTtcbiAgICBhd2FpdCBsb2dvdXQoKTtcbiAgICB0b2FzdFN1Y2Nlc3MoXCJTaWduZWQgb3V0LiBTZWUgeW91IHNvb24hXCIpO1xuICAgIG5hdmlnYXRlKFwiL1wiKTtcbiAgfVxuPC9zY3JpcHQ+XG5cbjxoZWFkZXI+XG4gIDxkaXYgY2xhc3M9XCJiYXJcIj5cbiAgICA8YSBjbGFzcz1cImJyYW5kXCIgaHJlZj1cIi9cIiBhcmlhLWxhYmVsPVwiVXBzb3JvayBob21lXCI+XG4gICAgICA8c3ZnIHZpZXdCb3g9XCIwIDAgNjQgNjRcIiBhcmlhLWhpZGRlbj1cInRydWVcIj5cbiAgICAgICAgPHJlY3Qgd2lkdGg9XCI2NFwiIGhlaWdodD1cIjY0XCIgcng9XCIxNlwiIGZpbGw9XCJ2YXIoLS1hY2NlbnQpXCIgLz5cbiAgICAgICAgPHBhdGhcbiAgICAgICAgICBkPVwiTTIwIDE0djE2YTYgNiAwIDAgMCA2IDZ2MTRhMiAyIDAgMCAwIDQgMFYzNmE2IDYgMCAwIDAgNi02VjE0YTIgMiAwIDAgMC00IDB2MTJhMiAyIDAgMCAxLTQgMFYxNGEyIDIgMCAwIDAtNCAwdjEyYTIgMiAwIDAgMS00IDBWMTRhMiAyIDAgMCAwLTQgMFpcIlxuICAgICAgICAgIGZpbGw9XCIjZmZmXCJcbiAgICAgICAgLz5cbiAgICAgICAgPHBhdGggZD1cIk00NCAxNGMtMyAzLTQgOC00IDEzczIgOCA0IDl2MTRhMiAyIDAgMCAwIDQgMFYxNGEyIDIgMCAwIDAtNCAwWlwiIGZpbGw9XCIjZmZmXCIgLz5cbiAgICAgIDwvc3ZnPlxuICAgICAgPHNwYW4+VXBzb3Jvazwvc3Bhbj5cbiAgICA8L2E+XG5cbiAgICA8U2VhcmNoQmFyIC8+XG5cbiAgICA8bmF2PlxuICAgICAgPGJ1dHRvbiBjbGFzcz1cImdob3N0IHRoZW1lXCIgdHlwZT1cImJ1dHRvblwiIG9uY2xpY2s9eygpID0+IGN5Y2xlVGhlbWUoKX0gdGl0bGU9XCJUaGVtZToge3RoZW1lTGFiZWx9XCI+XG4gICAgICAgIHsjaWYgcHJlZnMudGhlbWUgPT09IFwiZGFya1wiffCfjJl7OmVsc2UgaWYgcHJlZnMudGhlbWUgPT09IFwibGlnaHRcIn3imIDvuI97OmVsc2V98J+Ml3svaWZ9XG4gICAgICAgIDxzcGFuIGNsYXNzPVwic3Itb25seVwiPlN3aXRjaCB0aGVtZSAoY3VycmVudGx5IHt0aGVtZUxhYmVsfSk8L3NwYW4+XG4gICAgICA8L2J1dHRvbj5cblxuICAgICAgeyNpZiBzZXNzaW9uLnVzZXJ9XG4gICAgICAgIDxkaXYgY2xhc3M9XCJtZW51LXdyYXBcIj5cbiAgICAgICAgICA8YnV0dG9uIGNsYXNzPVwiYXZhdGFyLWJ1dHRvblwiIHR5cGU9XCJidXR0b25cIiBvbmNsaWNrPXsoKSA9PiAobWVudU9wZW4gPSAhbWVudU9wZW4pfSBhcmlhLWV4cGFuZGVkPXttZW51T3Blbn0+XG4gICAgICAgICAgICA8QXZhdGFyIHVzZXI9e3Nlc3Npb24udXNlcn0gc2l6ZT17MzR9IC8+XG4gICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgeyNpZiBtZW51T3Blbn1cbiAgICAgICAgICAgIDxidXR0b24gdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiYmFja2Ryb3BcIiBhcmlhLWxhYmVsPVwiQ2xvc2UgbWVudVwiIG9uY2xpY2s9eygpID0+IChtZW51T3BlbiA9IGZhbHNlKX0+PC9idXR0b24+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwibWVudVwiPlxuICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwid2hvXCI+XG4gICAgICAgICAgICAgICAgPHN0cm9uZz57c2Vzc2lvbi51c2VyLmRpc3BsYXlOYW1lfTwvc3Ryb25nPlxuICAgICAgICAgICAgICAgIDxzcGFuPntzZXNzaW9uLnVzZXIuZW1haWx9PC9zcGFuPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgPGEgaHJlZj1cIi9tZVwiIG9uY2xpY2s9eygpID0+IChtZW51T3BlbiA9IGZhbHNlKX0+WW91ciBsaXN0ICZhbXA7IHJldmlld3M8L2E+XG4gICAgICAgICAgICAgIHsjaWYgc2Vzc2lvbi51c2VyLnJvbGUgPT09IFwiYWRtaW5cIn1cbiAgICAgICAgICAgICAgICA8YSBocmVmPVwiL2FkbWluXCIgb25jbGljaz17KCkgPT4gKG1lbnVPcGVuID0gZmFsc2UpfT5BZG1pbjwvYT5cbiAgICAgICAgICAgICAgey9pZn1cbiAgICAgICAgICAgICAgPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgb25jbGljaz17c2lnbk91dH0+U2lnbiBvdXQ8L2J1dHRvbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIHsvaWZ9XG4gICAgICAgIDwvZGl2PlxuICAgICAgezplbHNlIGlmIHNlc3Npb24ubG9hZGVkfVxuICAgICAgICA8YSBjbGFzcz1cImdob3N0XCIgaHJlZj1cIi9sb2dpblwiPkxvZyBpbjwvYT5cbiAgICAgICAgPGEgY2xhc3M9XCJwcmltYXJ5XCIgaHJlZj1cIi9yZWdpc3RlclwiPkpvaW48L2E+XG4gICAgICB7L2lmfVxuICAgIDwvbmF2PlxuICA8L2Rpdj5cbjwvaGVhZGVyPlxuXG48c3R5bGU+XG4gIGhlYWRlciB7XG4gICAgcG9zaXRpb246IHN0aWNreTtcbiAgICB0b3A6IDA7XG4gICAgei1pbmRleDogNTA7XG4gICAgYmFja2dyb3VuZDogY29sb3ItbWl4KGluIHNyZ2IsIHZhcigtLXBhcGVyKSA4OCUsIHRyYW5zcGFyZW50KTtcbiAgICBiYWNrZHJvcC1maWx0ZXI6IGJsdXIoMTJweCk7XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIHZhcigtLWxpbmUpO1xuICB9XG5cbiAgLmJhciB7XG4gICAgbWF4LXdpZHRoOiB2YXIoLS1tYXgtdyk7XG4gICAgbWFyZ2luOiAwIGF1dG87XG4gICAgcGFkZGluZzogMTJweCAyMHB4O1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDE2cHg7XG4gIH1cblxuICAuYnJhbmQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDlweDtcbiAgICBmb250LWZhbWlseTogdmFyKC0tZm9udCk7XG4gICAgZm9udC1zaXplOiAxLjI4cmVtO1xuICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgY29sb3I6IHZhcigtLWFjY2VudCk7XG4gICAgZmxleDogbm9uZTtcbiAgfVxuICAuYnJhbmQgc3ZnIHsgd2lkdGg6IDMwcHg7IGhlaWdodDogMzBweDsgYm9yZGVyLXJhZGl1czogOXB4OyB9XG5cbiAgbmF2IHsgZGlzcGxheTogZmxleDsgYWxpZ24taXRlbXM6IGNlbnRlcjsgZ2FwOiA4cHg7IGZsZXg6IG5vbmU7IH1cblxuICAuZ2hvc3QsIC5wcmltYXJ5IHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGdhcDogNnB4O1xuICAgIHBhZGRpbmc6IDlweCAxNXB4O1xuICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLXJhZGl1cy1waWxsKTtcbiAgICBmb250LXNpemU6IDAuOXJlbTtcbiAgICBmb250LXdlaWdodDogNjAwO1xuICAgIGJvcmRlcjogMXB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIH1cbiAgLmdob3N0IHsgY29sb3I6IHZhcigtLWluay1zb2Z0KTsgfVxuICAuZ2hvc3Q6aG92ZXIgeyBiYWNrZ3JvdW5kOiB2YXIoLS1jYXJkKTsgY29sb3I6IHZhcigtLWluayk7IGJvcmRlci1jb2xvcjogdmFyKC0tbGluZSk7IH1cbiAgLnByaW1hcnkgeyBiYWNrZ3JvdW5kOiB2YXIoLS1hY2NlbnQpOyBjb2xvcjogI2ZmZjsgfVxuICAucHJpbWFyeTpob3ZlciB7IGJhY2tncm91bmQ6IHZhcigtLWFjY2VudC1kYXJrKTsgfVxuICAudGhlbWUgeyBmb250LXNpemU6IDFyZW07IHBhZGRpbmc6IDhweCAxMXB4OyB9XG5cbiAgLm1lbnUtd3JhcCB7IHBvc2l0aW9uOiByZWxhdGl2ZTsgfVxuICAuYXZhdGFyLWJ1dHRvbiB7IGJhY2tncm91bmQ6IG5vbmU7IGJvcmRlcjogbm9uZTsgcGFkZGluZzogMDsgY3Vyc29yOiBwb2ludGVyOyBib3JkZXItcmFkaXVzOiA1MCU7IH1cbiAgLmJhY2tkcm9wIHsgcG9zaXRpb246IGZpeGVkOyBpbnNldDogMDsgei1pbmRleDogNTU7IGJvcmRlcjogbm9uZTsgYmFja2dyb3VuZDogbm9uZTsgY3Vyc29yOiBkZWZhdWx0OyBwYWRkaW5nOiAwOyB9XG5cbiAgLm1lbnUge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICByaWdodDogMDtcbiAgICB0b3A6IGNhbGMoMTAwJSArIDEwcHgpO1xuICAgIHotaW5kZXg6IDYwO1xuICAgIG1pbi13aWR0aDogMjE4cHg7XG4gICAgYmFja2dyb3VuZDogdmFyKC0tY2FyZCk7XG4gICAgYm9yZGVyOiAxcHggc29saWQgdmFyKC0tbGluZSk7XG4gICAgYm9yZGVyLXJhZGl1czogdmFyKC0tcmFkaXVzKTtcbiAgICBib3gtc2hhZG93OiB2YXIoLS1zaGFkb3ctbGcpO1xuICAgIHBhZGRpbmc6IDZweDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIH1cbiAgLm1lbnUgLndobyB7XG4gICAgcGFkZGluZzogMTBweCAxMnB4IDEycHg7XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIHZhcigtLWxpbmUpO1xuICAgIG1hcmdpbi1ib3R0b206IDZweDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAycHg7XG4gIH1cbiAgLm1lbnUgLndobyBzcGFuIHsgZm9udC1zaXplOiAwLjc4cmVtOyBjb2xvcjogdmFyKC0taW5rLWZhaW50KTsgb3ZlcmZsb3c6IGhpZGRlbjsgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7IH1cbiAgLm1lbnUgYSwgLm1lbnUgYnV0dG9uIHtcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAgIHBhZGRpbmc6IDEwcHggMTJweDtcbiAgICBib3JkZXItcmFkaXVzOiB2YXIoLS1yYWRpdXMtc20pO1xuICAgIGJvcmRlcjogbm9uZTtcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGZvbnQtc2l6ZTogMC45cmVtO1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuICAubWVudSBhOmhvdmVyLCAubWVudSBidXR0b246aG92ZXIgeyBiYWNrZ3JvdW5kOiB2YXIoLS1hY2NlbnQtc29mdCk7IH1cblxuICBAbWVkaWEgKG1heC13aWR0aDogNzIwcHgpIHtcbiAgICAuYmFyIHsgZmxleC13cmFwOiB3cmFwOyBwYWRkaW5nOiAxMHB4IDE0cHg7IGdhcDogMTBweDsgfVxuICAgIC5icmFuZCBzcGFuIHsgZGlzcGxheTogbm9uZTsgfVxuICAgIDpnbG9iYWwoLnNlYXJjaCkgeyBvcmRlcjogMzsgZmxleC1iYXNpczogMTAwJTsgfVxuICB9XG48L3N0eWxlPlxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUF5RUEsRUFBRSxvQkFBTSxDQUFDO0FBQ1QsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSxNQUFNO0FBQ1YsSUFBSSxXQUFXO0FBQ2YsSUFBSSw2REFBNkQ7QUFDakUsSUFBSSwyQkFBMkI7QUFDL0IsSUFBSSxvQ0FBb0M7QUFDeEM7O0FBRUEsRUFBRSxrQkFBSSxDQUFDO0FBQ1AsSUFBSSx1QkFBdUI7QUFDM0IsSUFBSSxjQUFjO0FBQ2xCLElBQUksa0JBQWtCO0FBQ3RCLElBQUksYUFBYTtBQUNqQixJQUFJLG1CQUFtQjtBQUN2QixJQUFJLFNBQVM7QUFDYjs7QUFFQSxFQUFFLG9CQUFNLENBQUM7QUFDVCxJQUFJLGFBQWE7QUFDakIsSUFBSSxtQkFBbUI7QUFDdkIsSUFBSSxRQUFRO0FBQ1osSUFBSSx3QkFBd0I7QUFDNUIsSUFBSSxrQkFBa0I7QUFDdEIsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSxvQkFBb0I7QUFDeEIsSUFBSSxVQUFVO0FBQ2Q7QUFDQSxFQUFFLG9CQUFNLENBQUMseUJBQUcsQ0FBQyxFQUFFLFdBQVcsRUFBRSxZQUFZLEVBQUUsa0JBQWtCOztBQUU1RCxFQUFFLGlCQUFHLENBQUMsRUFBRSxhQUFhLEVBQUUsbUJBQW1CLEVBQUUsUUFBUSxFQUFFLFVBQVU7O0FBRWhFLEVBQUUsb0JBQU0sRUFBRSxzQkFBUSxDQUFDO0FBQ25CLElBQUksb0JBQW9CO0FBQ3hCLElBQUksbUJBQW1CO0FBQ3ZCLElBQUksdUJBQXVCO0FBQzNCLElBQUksUUFBUTtBQUNaLElBQUksaUJBQWlCO0FBQ3JCLElBQUksaUNBQWlDO0FBQ3JDLElBQUksaUJBQWlCO0FBQ3JCLElBQUksZ0JBQWdCO0FBQ3BCLElBQUksNkJBQTZCO0FBQ2pDLElBQUksZUFBZTtBQUNuQixJQUFJLGdCQUFnQjtBQUNwQixJQUFJLG1CQUFtQjtBQUN2QjtBQUNBLEVBQUUsb0JBQU0sQ0FBQyxFQUFFLHNCQUFzQjtBQUNqQyxFQUFFLG9CQUFNLE1BQU0sQ0FBQyxFQUFFLHVCQUF1QixFQUFFLGlCQUFpQixFQUFFLHlCQUF5QjtBQUN0RixFQUFFLHNCQUFRLENBQUMsRUFBRSx5QkFBeUIsRUFBRSxXQUFXO0FBQ25ELEVBQUUsc0JBQVEsTUFBTSxDQUFDLEVBQUUsOEJBQThCO0FBQ2pELEVBQUUsb0JBQU0sQ0FBQyxFQUFFLGVBQWUsRUFBRSxpQkFBaUI7O0FBRTdDLEVBQUUsd0JBQVUsQ0FBQyxFQUFFLGtCQUFrQjtBQUNqQyxFQUFFLDRCQUFjLENBQUMsRUFBRSxnQkFBZ0IsRUFBRSxZQUFZLEVBQUUsVUFBVSxFQUFFLGVBQWUsRUFBRSxrQkFBa0I7QUFDbEcsRUFBRSx1QkFBUyxDQUFDLEVBQUUsZUFBZSxFQUFFLFFBQVEsRUFBRSxXQUFXLEVBQUUsWUFBWSxFQUFFLGdCQUFnQixFQUFFLGVBQWUsRUFBRSxVQUFVOztBQUVqSCxFQUFFLG1CQUFLLENBQUM7QUFDUixJQUFJLGtCQUFrQjtBQUN0QixJQUFJLFFBQVE7QUFDWixJQUFJLHNCQUFzQjtBQUMxQixJQUFJLFdBQVc7QUFDZixJQUFJLGdCQUFnQjtBQUNwQixJQUFJLHVCQUF1QjtBQUMzQixJQUFJLDZCQUE2QjtBQUNqQyxJQUFJLDRCQUE0QjtBQUNoQyxJQUFJLDRCQUE0QjtBQUNoQyxJQUFJLFlBQVk7QUFDaEIsSUFBSSxhQUFhO0FBQ2pCLElBQUksc0JBQXNCO0FBQzFCO0FBQ0EsRUFBRSxtQkFBSyxDQUFDLDBCQUFJLENBQUM7QUFDYixJQUFJLHVCQUF1QjtBQUMzQixJQUFJLG9DQUFvQztBQUN4QyxJQUFJLGtCQUFrQjtBQUN0QixJQUFJLGFBQWE7QUFDakIsSUFBSSxzQkFBc0I7QUFDMUIsSUFBSSxRQUFRO0FBQ1o7QUFDQSxFQUFFLG1CQUFLLENBQUMsMEJBQUksQ0FBQywwQkFBSSxDQUFDLEVBQUUsa0JBQWtCLEVBQUUsdUJBQXVCLEVBQUUsZ0JBQWdCLEVBQUUsdUJBQXVCO0FBQzFHLEVBQUUsbUJBQUssQ0FBQyx1QkFBQyxFQUFFLG1CQUFLLENBQUMsNEJBQU0sQ0FBQztBQUN4QixJQUFJLGdCQUFnQjtBQUNwQixJQUFJLGtCQUFrQjtBQUN0QixJQUFJLCtCQUErQjtBQUNuQyxJQUFJLFlBQVk7QUFDaEIsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSxpQkFBaUI7QUFDckIsSUFBSSxlQUFlO0FBQ25CO0FBQ0EsRUFBRSxtQkFBSyxDQUFDLHVCQUFDLE1BQU0sRUFBRSxtQkFBSyxDQUFDLDRCQUFNLE1BQU0sQ0FBQyxFQUFFLDhCQUE4Qjs7QUFFcEUsRUFBRSwwQkFBMEI7QUFDNUIsSUFBSSxrQkFBSSxDQUFDLEVBQUUsZUFBZSxFQUFFLGtCQUFrQixFQUFFLFNBQVM7QUFDekQsSUFBSSxvQkFBTSxDQUFDLDBCQUFJLENBQUMsRUFBRSxhQUFhO0FBQy9CLElBQVksT0FBUSxDQUFDLEVBQUUsUUFBUSxFQUFFLGdCQUFnQjtBQUNqRDsifQ== */'
};

export default function Header($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Header);
	$.append_styles($$anchor, $$css);

	let menuOpen = $.tag($.state(false), 'menuOpen');

	const themeLabel = $.tag(
		$.derived(() => $.strict_equals(prefs.theme, "dark")
			? "Dark"
			: $.strict_equals(prefs.theme, "light") ? "Light" : "Auto"),
		'themeLabel'
	);

	async function signOut() {
		$.set(menuOpen, false);
		(await $.track_reactivity_loss(logout()))();
		toastSuccess("Signed out. See you soon!");
		navigate("/");
	}

	var $$exports = { ...$.legacy_api() };
	var header = root_4();
	var div = $.child(header);
	var node = $.sibling($.child(div), 2);

	$.add_svelte_meta(() => SearchBar(node, {}), 'component', Header, 37, 4, { componentTag: 'SearchBar' });

	var nav = $.sibling(node, 2);
	var button = $.child(nav);
	var node_1 = $.child(button);

	{
		var consequent = ($$anchor) => {
			var text = $.text('🌙');

			$.append($$anchor, text);
		};

		var consequent_1 = ($$anchor) => {
			var text_1 = $.text('☀️');

			$.append($$anchor, text_1);
		};

		var alternate = ($$anchor) => {
			var text_2 = $.text('🌗');

			$.append($$anchor, text_2);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.strict_equals(prefs.theme, "dark")) $$render(consequent); else if ($.strict_equals(prefs.theme, "light")) $$render(consequent_1, 1); else $$render(alternate, -1);
			}),
			'if',
			Header,
			41,
			8
		);
	}

	var span = $.sibling(node_1, 2);
	var text_3 = $.child(span);

	$.reset(span);
	$.reset(button);

	var node_2 = $.sibling(button, 2);

	{
		var consequent_4 = ($$anchor) => {
			var div_1 = root_2();
			var button_1 = $.child(div_1);
			var node_3 = $.child(button_1);

			$.add_svelte_meta(
				() => Avatar(node_3, {
					get user() {
						return session.user;
					},
					size: 34
				}),
				'component',
				Header,
				48,
				12,
				{ componentTag: 'Avatar' }
			);

			$.reset(button_1);

			var node_4 = $.sibling(button_1, 2);

			{
				var consequent_3 = ($$anchor) => {
					var fragment = root_1();
					var button_2 = $.first_child(fragment);
					var div_2 = $.sibling(button_2, 2);
					var div_3 = $.child(div_2);
					var strong = $.child(div_3);
					var text_4 = $.child(strong, true);

					$.reset(strong);

					var span_1 = $.sibling(strong, 2);
					var text_5 = $.child(span_1, true);

					$.reset(span_1);
					$.reset(div_3);

					var a = $.sibling(div_3, 2);
					var node_5 = $.sibling(a, 2);

					{
						var consequent_2 = ($$anchor) => {
							var a_1 = root();

							$.delegated('click', a_1, function click_4() {
								return $.set(menuOpen, false);
							});

							$.append($$anchor, a_1);
						};

						$.add_svelte_meta(
							() => $.if(node_5, ($$render) => {
								if ($.strict_equals(session.user.role, "admin")) $$render(consequent_2);
							}),
							'if',
							Header,
							58,
							14
						);
					}

					var button_3 = $.sibling(node_5, 2);

					$.reset(div_2);

					$.template_effect(() => {
						$.set_text(text_4, session.user.displayName);
						$.set_text(text_5, session.user.email);
					});

					$.delegated('click', button_2, function click_2() {
						return $.set(menuOpen, false);
					});

					$.delegated('click', a, function click_3() {
						return $.set(menuOpen, false);
					});

					$.delegated('click', button_3, signOut);
					$.append($$anchor, fragment);
				};

				$.add_svelte_meta(
					() => $.if(node_4, ($$render) => {
						if ($.get(menuOpen)) $$render(consequent_3);
					}),
					'if',
					Header,
					50,
					10
				);
			}

			$.reset(div_1);
			$.template_effect(() => $.set_attribute(button_1, 'aria-expanded', $.get(menuOpen)));

			$.delegated('click', button_1, function click_1() {
				return $.set(menuOpen, !$.get(menuOpen));
			});

			$.append($$anchor, div_1);
		};

		var consequent_5 = ($$anchor) => {
			var fragment_1 = root_3();

			$.next(2);
			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if (session.user) $$render(consequent_4); else if (session.loaded) $$render(consequent_5, 1);
			}),
			'if',
			Header,
			45,
			6
		);
	}

	$.reset(nav);
	$.reset(div);
	$.reset(header);

	$.template_effect(() => {
		$.set_attribute(button, 'title', `Theme: ${$.get(themeLabel) ?? ''}`);
		$.set_text(text_3, `Switch theme (currently ${$.get(themeLabel) ?? ''})`);
	});

	$.delegated('click', button, function click() {
		return cycleTheme();
	});

	$.append($$anchor, header);

	return $.pop($$exports);
}

$.delegate(['click']);